import { computePompageOpex } from './pompageCalculations.js';
import { computeFiltrationOpex } from './filtrationCalculations.js';

/**
 * OPEX annuel agrégé (électricité de pompage + consommables de filtration). Retourne un
 * breakdown pour cohérence avec les autres compute*Cost, mais l'UI (RoiStep) n'affiche
 * que le total low/high — pas de détail poste par poste, par choix produit.
 * @param {Object} budgetState - { pompage, filtration, ... }
 */
export const computeOpex = (budgetState) => {
  const pompageOpex = computePompageOpex(budgetState.pompage);
  const filtrationOpex = computeFiltrationOpex(budgetState.filtration);

  const breakdown = [];
  if (pompageOpex.low > 0 || pompageOpex.high > 0) {
    breakdown.push({ name: 'Électricité pompage', low: pompageOpex.low, high: pompageOpex.high });
  }
  if (filtrationOpex.low > 0 || filtrationOpex.high > 0) {
    breakdown.push({ name: 'Consommables de filtration', low: filtrationOpex.low, high: filtrationOpex.high });
  }

  return {
    breakdown,
    low: pompageOpex.low + filtrationOpex.low,
    high: pompageOpex.high + filtrationOpex.high,
  };
};
